export default __webpack_public_path__ + "static/media/UTPL_Fiscal_2022.2262c454.pdf";